/**
  根據服務 ID 回傳對應的 Line 官方帳號連結
  @param {number|string} serviceId 服務 ID
  @return {string} Line 官方帳號連結
*/
const getServiceLineLink = (serviceId) => {
  const formattedServiceId = serviceId ? serviceId.toString() : null
  let lineId = '@ljs8129j'
  switch (formattedServiceId) {
    case '1305':
    case '1562':
      lineId = '@153ujovj'
      break
    default:
      break
  }
  return `https://line.me/R/ti/p/${lineId}`
}

export default getServiceLineLink
